import React from 'react'
import { FormField, SemanticWIDTHS } from 'semantic-ui-react'
import { Field } from 'react-final-form'
import { PatternFormat } from 'react-number-format'

import { useFieldError } from '../../../hooks/useFieldError'

interface MaskedProps {
  id?: string
  name: string
  mask: string
  label?: string
  required?: boolean
  disabled?: boolean
  width?: SemanticWIDTHS
  fluid?: boolean
  readOnly?: boolean
  autoComplete?: string
  onBlur?: (event: any) => void
  onValueChange?: (values: any) => void
}

export const Masked: React.FC<MaskedProps> = ({
  name,
  mask,
  onBlur,
  id = name,
  ...rest
}) => {
  return (
    <Field name={name}>
      {({ input, meta }) => {
        const error = useFieldError({ input, meta })

        const handleValueChange = (values: any) => {
          // Atualiza o valor no react-final-form
          input.onChange(values.value)
        }

        const handleBlur = (event: any) => {
          input.onBlur(event)
          if (onBlur) {
            onBlur(event)
          }
        }

        return (
          <FormField
            id={id}
            control={PatternFormat}
            {...rest}
            name={input.name}
            value={input.value || ''}
            format={mask}
            error={error}
            onValueChange={handleValueChange}
            onBlur={handleBlur}
            onFocus={input.onFocus}
          />
        )
      }}
    </Field>
  )
}
